var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReactionFilled = function SvgReactionFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reaction-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.667 14.338v-4.75L4.053 5.154a.865.865 0 0 0-.948-.577.833.833 0 0 0-.633 1.104l2.103 5.78a.208.208 0 0 1-.295.255L2.236 10.61a1.042 1.042 0 0 0-1.187 1.7l5.163 4.404a5.633 5.633 0 0 1-.545-2.376ZM7.792 5.68a1.767 1.767 0 0 1 1.356 1.288l.015.052.144 1.164.708-1.262L8.324 2.27a.864.864 0 0 0-.949-.578.833.833 0 0 0-.633 1.106l1.05 2.883ZM10.555 5.963l1.072-1.908a.834.834 0 0 0-1.167-.382.865.865 0 0 0-.355 1.052l.45 1.238ZM5.69 7.215a1.82 1.82 0 0 1 1.23-1.493l-1.087-2.99a.864.864 0 0 0-.949-.577.833.833 0 0 0-.634 1.106l1.44 3.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.246 9.022a.897.897 0 0 0-1.083.39l-1.836 3.216a.417.417 0 1 1-.724-.413l3.284-5.75a.864.864 0 0 0-.172-1.096.833.833 0 0 0-1.253.23l-3.307 5.79a.417.417 0 0 1-.723-.413l3.49-6.112a.864.864 0 0 0-.172-1.1.833.833 0 0 0-1.253.232l-3.512 6.151a.417.417 0 1 1-.724-.413l2.664-4.667a.864.864 0 0 0-.173-1.094.833.833 0 0 0-1.252.231l-3.397 6.042a.208.208 0 0 1-.388-.077L8.34 7.175a.935.935 0 0 0-.985-.699.976.976 0 0 0-.855.99v6.867a4.786 4.786 0 0 0 2.412 4.137 5.108 5.108 0 0 0 7.002-1.76l3.72-6.512a.833.833 0 0 0-.388-1.176Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reaction-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z",
    transform: "translate(.25 .43)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReactionFilled);
export default ForwardRef;